{
  "01": "gtin",
  "8006": "itip",
  "8013": "gmn",
  "8010": "cpid",
  "414": "gln",
  "417": "partyGln",
  "8017": "gsrnp",
  "8018": "gsrn",
  "255": "gcn",
  "00": "sscc",
  "253": "gdti",
  "401": "ginc",
  "402": "gsin",
  "8003": "grai",
  "8004": "giai",
  "22": "cpv",
  "10": "lot",
  "21": "ser",
  "8011": "cpsn",
  "254": "glnx",
  "8020": "refno",
  "8019": "srin",
  "235": "tpx",
  "7040": "uic-ext"
}
